// Helpers for showing a property owner's email/SMS history alongside the manual
// Agent Notes (Paul Jimoulis, DOMA 13234622777 / CRM-2026-00102: "Please add
// email/text communication to agent notes section to follow"). The comms rows
// are CommunicationLog entries from GET /api/communications/timeline/.

const _time = (v) => {
  const t = v ? new Date(v).getTime() : NaN;
  return Number.isFinite(t) ? t : -Infinity; // undated rows sink to the bottom
};

export const channelLabel = (c) =>
  (c?.channel || "").toLowerCase() === "sms" ? "SMS" : "Email";

export const directionLabel = (c) =>
  (c?.direction || "").toLowerCase() === "inbound" ? "Received" : "Sent";

// Who to credit a comm row to: the staff member who sent it, or the owner for an
// inbound reply, falling back to a neutral label for automated sends.
export const commAuthor = (c) =>
  c?.sent_by_name ||
  ((c?.direction || "").toLowerCase() === "inbound"
    ? c?.contact_name || "Owner"
    : "System");

// Merge manual notes and comm rows into one timeline, newest first. Each item is
// { kind: 'note'|'comm', key, ts, data } so the panel can render either shape.
export function mergeNotesAndComms(notes = [], comms = []) {
  const items = [
    ...(notes || []).map((n) => ({
      kind: "note",
      key: `note-${n.id}`,
      ts: _time(n.created_at),
      data: n,
    })),
    ...(comms || []).map((c) => ({
      kind: "comm",
      key: `comm-${c.id}`,
      ts: _time(c.occurred_at),
      data: c,
    })),
  ];
  return items.sort((a, b) => b.ts - a.ts);
}

// Comm rows re-shaped as {body, created_at, author} so they feed the same AI
// summary the manual notes do (the summary reads that shape).
export function commsToSummaryNotes(comms = []) {
  return (comms || []).map((c) => ({
    body: `${channelLabel(c)} ${directionLabel(c).toLowerCase()}${
      c.subject_or_preview ? `: ${c.subject_or_preview}` : ""
    }`,
    created_at: c.occurred_at,
    author: commAuthor(c),
  }));
}

// Owner lookup params for the comms timeline, or null when there's nothing to
// look them up by. Prefer a resolved owner contact id, else the owner's email.
export function ownerCommsParams(property) {
  if (!property) return null;
  const email = (property.owner_email || "").trim();
  if (email) return { email };
  return null;
}
